import * as React from 'react';
import * as cx from 'classnames';
import { SuperCriticalComponent, SuperCriticalReference } from 'lib/supercritical';

interface PCAutoScrollProps {
    keepInView : () => boolean;
    scrollParent? : (el : HTMLDivElement) => HTMLElement | null;
    retriggerScroll? : () => void;
    className? : string;
    onClick? : () => void;
    children? : any;
}

// Utility view to scroll a container element vertically to a selected child element.
// Put this around the child element.
export class PCAutoScroll extends SuperCriticalComponent<PCAutoScrollProps> {
    ref : (el : HTMLDivElement | null) => void;

    constructor(props : PCAutoScrollProps) {
        super(props);
        this.ref = SuperCriticalReference(this, ({ keepInView, scrollParent, retriggerScroll } : PCAutoScrollProps, el : HTMLDivElement) => {
            if (keepInView()) {
                if (retriggerScroll) retriggerScroll();

                // TH 12/07/2016 -- requestAnimationFrame so we give the DOM a chance to update after a retriggerScroll.
                window.requestAnimationFrame(() => {
                    // TH 12/07/2016 -- Scroll element into view.
                    // Tried el.scrollIntoView, but it cause the whole page to move, so seemed way
                    // to jumpy for the current applications.
                    // Down the road, could maybe pass a flag for different scroll behaviors.

                    const parentElement = scrollParent ? scrollParent(el) : el.parentElement;

                    if (!parentElement) return;

                    // maximum for el not to fall off the top
                    const maxScrollTop = el.offsetTop - parentElement.offsetTop,
                        scrollTop = parentElement.scrollTop;
                    if (scrollTop > maxScrollTop) {
                        parentElement.scrollTop = maxScrollTop;
                    } else {
                        // minimum for el not to fall off bottom
                        const minScrollTop = maxScrollTop + el.offsetHeight - parentElement.clientHeight;
                        if (scrollTop < minScrollTop) parentElement.scrollTop = minScrollTop;
                    }
                });
            }
        });
    }

    srender({ className, onClick, children } : PCAutoScrollProps) {
        return (
            <div className={cx('pc-auto-scroll', {
                    clickable: !!onClick
                }, className)}
                onClick={onClick}
                ref={this.ref}>
                {children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/pcautoscroll/view.tsx